import type { NodeCG } from '../../types/nodecg';
export const filteredConfig = (globalThis as any).ncgConfig as NodeCG.FilteredConfig;
